import Icon from '../../../components/AppIcon';

const BenefitCard = ({ icon, title, description }) => {
  return (
    <div className="flex gap-4 p-4 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-300">
      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
        <Icon name={icon} size={24} color="var(--color-primary)" />
      </div>
      <div className="flex-1">
        <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default BenefitCard;